import { render, staticRenderFns } from "./LeadsPageContent.vue?vue&type=template&id=0aafa94c&scoped=true&"
import script from "./LeadsPageContent.vue?vue&type=script&lang=js&"
export * from "./LeadsPageContent.vue?vue&type=script&lang=js&"
import style0 from "./LeadsPageContent.vue?vue&type=style&index=0&id=0aafa94c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafa94c",
  null
  
)

export default component.exports